<script>
import Product from '@/models/Product';
import XLSX from 'xlsx';

import productComponent from './product_component/product_component.vue';

export default {
  data() {
    return {
      editProductsIsValid: null,
      isButtonActive: true,
    };
  },
  props: ['order'],
  components: {
    product_component: productComponent,
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (typeof this.order.products === 'undefined') {
        this.order.products = [];
        return;
      }

      this.order.products.forEach((product) => {
        product.loadProductInfo = false;
        product.valid = true;

        return product;
      });
    },
    loadInBoundFile(file) {
      if (!file) return;

      new Promise((resolve, reject) => {
        const r = new FileReader();

        r.onload = (() => (e) => {
          const contents = e.target.result;
          const workbook = XLSX.read(contents, {type: 'binary'});
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];

          const data = XLSX.utils.sheet_to_json(worksheet, {raw: true});
          resolve(data);
        })();

        r.onerror = reject;

        r.readAsBinaryString(file);
      }).then((data) => {
        data.forEach((item) => {
          const {Asin: asin, Quantity: qty = 1, Comment: comment = ''} = item;
          this.addProduct(null, asin, qty, comment)
        });
      });
    },
    async addProduct(event, asin = '', qty = 1, comment = '', bundle_type = 'SINGLE', in_set = 1) {
      const existed = this.order.products.find((product) => product.asin === asin && asin !== '');
      if (existed) {
        existed.quantity += qty;

        if (comment !== '' && comment !== existed.client_comment) {
          existed.client_comment += `\n${comment}`;
        }
        return;
      }

      let image = '';
      let title = '';
      let product_id;

      if (typeof asin !== 'undefined' || asin.length === 10) {
        await this.$store.dispatch('getASINInfo', asin)
          .then((data) => {
            image = data.image;
            title = data.title;
            product_id = data.id;
          })
          .catch((ex) => {
            console.log('ERROR:', ex);
          });
      }

      const item = {
        product_id,
        asin,
        title,
        image,
        quantity: qty,
        bundle_type,
        in_set,
        client_comment: comment,
        valid: true,
        loadProductInfo: false,

      };
      const product = new Product(item);

      this.order.products.push(product);
    },
    save() {
      const data = this.order.products.map((product) => {
        const getProduct = new Product(product);

        let item = {
          client_comment: getProduct.client_comment,
          quantity: getProduct.quantity,
          bundle_type: getProduct.bundle_type,
          in_set: getProduct.in_set,
          fnsku: getProduct.fnsku,
        };

        if (getProduct.is_non_amazon) {
          item.title = getProduct.fnsku_title;
        } else {
          item.product_id = getProduct.product_id;
        }

        return item;
      });

      this.isButtonActive = false;
      this.$store.dispatch('ib_update_order', {order_id: this.order.id, data})
        .finally(() => {
          this.isButtonActive = true;
        });
    },
    remove(index) {
      this.order.products.splice(index, 1);
    },
    close(event) {
      if (event === 'created') {
        this.$store.commit('set_instock_modal_order_products', null);
        this.$store.dispatch('ib_load_orders');
      }

      if (!event.target.closest('.modal-container') || event.target.classList.contains('close')) {
        this.$store.dispatch('ib_load_orders');
        this.$store.commit('set_instock_modal_order_products', null);
      }
    },
    setValidation(product, isValid) {
      const asins = this.order.products.map((item) => item.asin);
      const set = new Set(asins);
      if (set.length !== this.order.products.length) this.isButtonActive = false;

      this.order.products.forEach((item) => {
        item.valid = item.asin === product.asin ? isValid : item.valid;
      });

      this.isButtonActive = this.order.products.filter((item) => item.valid === false).length === 0;
    },
  },
};
</script>
<template src="./order_products.pug" lang="pug"></template>
